import { render, staticRenderFns } from "./SellPriceCategorySelect.vue?vue&type=template&id=655da611"
import script from "./SellPriceCategorySelect.vue?vue&type=script&lang=ts"
export * from "./SellPriceCategorySelect.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('655da611')) {
      api.createRecord('655da611', component.options)
    } else {
      api.reload('655da611', component.options)
    }
    module.hot.accept("./SellPriceCategorySelect.vue?vue&type=template&id=655da611", function () {
      api.rerender('655da611', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/SellPriceCategorySelect.vue"
export default component.exports